<!-- eslint-disable vue/no-mutating-props -->
<template>
  <!-- 财务类目新增 -->
  <dialogWrap
    v-model="show"
    :title="title"
    width="'1400px'"
    custom-class="dialog-message"
    :before-close="cancel"
    @close="cancel"
  >
    <QS-scroller-box>
      <el-form
        :model="formData"
        ref="formDataRef"
        label-width="130px"
        :rules="formRule"
        class="customerInfo"
      >
        <!-- <column-box :column="2" label-width="150px"> -->
        <el-row>
          <el-col :span="12">
            <el-form-item
              prop="oneCode"
              v-show="!formData.id"
              :label="`一级类目编码${columnSeparator}`"
            >
              <el-input
                style="width: 150px"
                v-model="formData.oneCode"
                placeholder="请输入"
                clearable
                v-number:integer.noTrim="4"
                @input="inputChange($event, 'oneCode')"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              prop="twoCode"
              v-show="!formData.id"
              :label="`二级类目编码${columnSeparator}`"
            >
              <el-input
                style="width: 150px"
                v-model="formData.twoCode"
                placeholder="请输入"
                clearable
                v-number:integer.noTrim="3"
                @input="inputChange($event, 'twoCode')"
                :disabled="isDisabled.twoDisabled"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              prop="threeCode"
              v-show="!formData.id"
              :label="`三级类目编码${columnSeparator}`"
            >
              <el-input
                style="width: 150px"
                v-model="formData.threeCode"
                placeholder="请输入"
                clearable
                @input="inputChange($event, 'threeCode')"
                v-number:integer.noTrim="2"
                :disabled="isDisabled.threeDisabled"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              prop="fourCode"
              v-show="!formData.id"
              :label="`四级类目编码${columnSeparator}`"
            >
              <el-input
                style="width: 150px"
                v-model="formData.fourCode"
                placeholder="请输入"
                clearable
                @input="inputChange($event, 'fourCode')"
                v-number:integer.noTrim="2"
                :disabled="isDisabled.fourDisabled"
              >
              </el-input>
              <!-- {{formData.customerName}} -->
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="code" :label="`类目编码${columnSeparator}`">
              <span style="width: 150px">{{ formData.code }}</span>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="name" :label="`类目名称${columnSeparator}`">
              <el-input
                style="width: 150px"
                v-model="formData.name"
                placeholder="请输入"
                clearable
                v-delete-emoji
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="state" :label="`状态${columnSeparator}`">
              <el-select
                style="width: 150px"
                placeholder="请选择"
                v-model="formData.state"
                clearable
              >
                <el-option
                  v-for="item in catStateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              prop="fundType"
              :label="`默认支付内容${columnSeparator}`"
            >
              <el-select
                style="width: 150px"
                placeholder="请选择"
                v-model="formData.fundType"
                clearable
              >
                <el-option
                  v-for="item in freeTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- </column-box> -->
      </el-form>
    </QS-scroller-box>
    <template slot="footer">
      <el-button @click="cancel" size="small">取消</el-button>
      <el-button :loading="submitLoading" @click="submit" size="small" type="primary"
        >确认</el-button
      >
    </template>
  </dialogWrap>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
import { editCategory, getCategoryAdd } from '@/api/financeApi'
import selectOption from '@/store/dict/selectOptionDict.js'
import { mapState } from 'vuex'

export default {
  name: 'CategoryAdd',
  props: {
    categoryShow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '新增',
    },
    formData: {
      type: Object,
      default: () => ({
        oneCode: '',
        twoCode: '',
        threeCode: '',
        fourCode: '',
        code: '',
        name: '',
        state: 1,
        fundType: '',
        // id: '' 编辑态有
      }),
    },
  },
  data() {
    return {
      submitLoading: false,
      // 表单规则
      formRule: {
        // 收款方类型 必填
        oneCode: [
          { required: true, message: '一级类目不能为空', trigger: 'blur' },
        ],
        // 收款方类型 必填
        twoCode: [
          { required: true, message: '二级类目不能为空', trigger: 'blur' },
        ],
        threeCode: [
          {
            required: true,
            message: '三级类目不能为空',
            trigger: 'blur',
          },
        ],
        fourCode: [
          {
            required: true,
            message: '四级类目不能为空',
            trigger: 'blur',
          },
        ],
        name: [
          {
            required: true,
            message: '类目名称不能为空',
            trigger: 'blur',
          },
        ],
        state: [
          {
            required: true,
            message: '请选择',
            trigger: 'change',
          },
        ],
      },
      // 类目禁选状态
      isDisabled: {
        twoDisabled: true,
        threeDisabled: true,
        fourDisabled: true,
      },
      show: false,
    }
  },
  methods: {
    isInputDisabled() {
      this.isDisabled.twoDisabled = !this.formData.oneCode
      this.isDisabled.threeDisabled = !this.formData.twoCode
      this.isDisabled.fourDisabled = !this.formData.threeCode
    },
    // 输入框更改
    inputChange(value, target) {
      this.isInputDisabled()
      this.formData[target] = value
      this.formData.code = this.formData.oneCode + this.formData.twoCode +
        this.formData.threeCode + this.formData.fourCode
    },
    // 确认
    submit() {
      this.$refs.formDataRef.validate((valid) => {
        if (valid) {
          this.addEditSubmit()
        } else {
          this.$message({
            message: '请填写必填项',
            type: 'error',
          })
        }
      })
    },
    // 取消
    cancel() {
      this.$emit('cancelHandle')
      this.$refs.formDataRef.resetFields()
      Object.assign(this.isDisabled, {
        twoDisabled: true,
        threeDisabled: true,
        fourDisabled: true,
      })
    },
    // 新增/编辑
    async addEditSubmit() {
      if (this.submitLoading) return
      this.submitLoading = true
      try {
        if (!this.formData.id) {
          const { code } = await getCategoryAdd({ ...this.formData })
          if (code !== 1) {
            this.submitLoading = false
            return
          }
        } else {
          const { code } = await editCategory({ ...this.formData })
          if (code !== 1) {
            this.submitLoading = false
            return
          }
        }
        this.$message({ message: !this.formData.id ? '新增成功' : '编辑成功', type: 'success' })
        this.$emit('submitSuccess')
        this.$refs.formDataRef.resetFields()
        Object.assign(this.isDisabled, {
          twoDisabled: true,
          threeDisabled: true,
          fourDisabled: true,
        })
      } catch {
        this.submitLoading = false
      }
    },

  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
    catStateList() {
      return this.dictParseList(selectOption.accountStateDict)
    },
  },
  watch: {
    categoryShow(val) {
      this.show = val
      this.isInputDisabled()
      if (val) {
        this.submitLoading = false
      } else {
        this.$refs.formDataRef.resetFields()
      }
    },
  },
}
</script>

<style></style>
